<template>
  <v-container fluid>
    <v-data-table
        :headers="headers"
        :items="facturas"
    >
      <template v-slot:no-data>
        Aún no agregaste facturas
      </template>
      <template v-slot:item.fechaFactura="{item}">
        {{item.fechaFactura}}
      </template>
      <template v-slot:item.montoFactura="{value}">
        {{value !== null ? Number(value).toLocaleString() : '-'}}
      </template>
      <template v-slot:body.append>
        <tr>
          <td></td>

          <td></td>
          <td></td>
          <td>{{valorTotal.toLocaleString()}}</td>
          <td></td>
        </tr>
      </template>
      <template v-slot:item.actions="{item}">
        <v-btn icon
               v-if="!readonly"
               @click="deleteItem(item)"
        ><v-icon>delete</v-icon></v-btn>
        <v-btn icon
               v-if="item.tieneArchivo"
               @click="downloadFile(item)"
        ><v-icon>get_app</v-icon></v-btn>
      </template>
    </v-data-table>
    <p class="error--text"
       v-for="message of errorMessages.facturas"
       v-if="errorMessages && errorMessages.facturas">
      {{message}}
    </p>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <FormDialog add-button-label="Agregar factura"
                    v-model="showForm"
                    v-if="!readonly"
                    @close="onClose()"
                @save="saveFactura()"
        >
          <template v-slot:form>
            <v-container fluid>
            <RemoteGenericForm
                v-model="formModel"
                @dtoLoaded="dto = $event"
                :errores-validacion="errors"
              base-url="factura"></RemoteGenericForm>
            <FileField
                v-if="formModel"
                label="Factura"
                :error-messages="errors['factura']"
                v-model="formModel['factura']"
            />

            </v-container>
          </template>
        </FormDialog>
      </v-col>
    </v-row>
    <DownloadFile
        v-for="archivo of toDownload"
        :key="archivo.id"
        :url="archivo.url"
        @finDescarga="popDescarga(archivo.id)"
    ></DownloadFile>
  </v-container>
</template>

<script>
import FormDialog from '@/components/FormDialog';
import RemoteGenericForm from '@/components/RemoteGenericForm';
import SelectorPartidaArancelaria from '@/views/formularios/SelectorPartidaArancelaria';
import FileField from '@/components/generic-fields/FileField';
import TextField from '@/components/generic-fields/TextField';
import DownloadFile from '@/components/DownloadFile';
import { flattenFields } from '@/components/utils/utils';
import moment from 'moment';

export default {

name: "FacturasStep",
  components: { TextField, FileField, SelectorPartidaArancelaria, RemoteGenericForm, FormDialog, DownloadFile },
  props: {
    baseUrl: {
      type: String,
      required: false,
      default: 'mercaderia'
    },
    value: {
      type: Array,
      default: () => []
    },
    errorMessages: {
      type: Object,
      default: () => ({}),
    },
    formValue: {
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    headers: [
      {text: 'Nro. Factura', value: 'nroFactura'},
      {text: 'Timbrado', value: 'timbrado'},
      {text: 'Fecha de la Factura', value: 'fechaFactura'},
      {text: 'Monto', value: 'montoFactura'},
      {text: '', value: 'actions'},
    ],
    dto: null,
    partida: null,
    facturas: [],
    showForm: false,
    lastId: 0,
    formModel: undefined,
    errors: {},
    totalDolares: null,
    toDownload: [],
  }),
  watch: {
    value() {
      this.facturas = this.value.map((v, idx) => {
        v.index = idx + 1;
        v.fechaFactura = v.fechaFactura ? moment(v.fechaFactura).format('YYYY-MM-DD') : '-';
        return v;
      });
    },
    valorTotal() {
      this.getTotalDolares();
    },
    "formModel.factura": {
      handler() {
        this.errors.factura = null;
      },
    },
  
    errorMessages() {
      this.errors = Object.assign({}, this.errorMessages);
    },
  },
  methods: {
    onClose() {
      for (let k of Object.keys(this.formModel)) {
        this.formModel[k] = null;
      }
      this.errors = {};
    },
    saveFactura() {
      if (!this.dto) return;
      let errores = {};
      for (let field of flattenFields(this.dto.fields)) {
        if (field.isRequired && (!this.formModel[field.fieldName] || this.formModel[field.fieldName] === '')) {
          errores[field.fieldName] = ['Es requerido', ];
        }
      }
      if (!this.formModel.factura) {
        errores['factura'] = ['Es requerido', ];
      }
      if (Object.keys(errores).length > 0) {
        this.errors = errores;
        return;
      }
      let factura = Object.assign({}, this.formModel);
      factura.index = this.facturas.length;
      factura.partidaArancelaria = this.partida ? this.partida.codigo : null;
      factura.id = this.lastId++;
      this.errorMessages.facturas = [];
      this.facturas.push(factura);
      this.$emit('input', this.facturas);
      for (let k of Object.keys(this.formModel)) {
        this.formModel[k] = null;
      }
      this.errors = {};
      this.showForm = false;
    },
    deleteItem(item) {
      let idx = this.facturas.findIndex(i => i.id === item.id);
      this.facturas.splice(idx);
      this.$emit('input', this.facturas);
    },
    getTotalDolares() {
      if (this.formValue && this.formValue.moneda && this.facturas && this.facturas.length > 0){
        this.$http.get(`${process.env.VUE_APP_ROOT_API}monedas/total-dolar`, {params: {
            valor: this.valorTotal,
            moneda: this.formValue.moneda
          }
        }).then(r => r.json()).then(conversion => {
          this.totalDolares = conversion.dolares.toFixed(2);
        });
      } else {
        this.totalDolares = null;
      }
    },
    downloadFile(item) {
      this.toDownload.push({
        id: item.id,
        url: `factura/${item.id}/descargar`
      });

    },
  },
  computed: {
    valorTotal() {
      return this.facturas ? this.facturas.map(m => m.montoFactura).reduce((tot, val) => tot + Number(val), 0) : 0;
    },

  },
}
</script>

<style scoped>

</style>
